<template>
  <div v-if="recipe">
    <!--    <image-gallery v-if="recipe.images" :images="recipe.images" />-->
    <v-flex>
      <v-layout class="gallery-preview elevation-4">
        <v-img
          v-if="recipe && recipe.image && recipe.image.data"
          :src="recipe && recipe.image && recipe.image.data"
          max-height="40vh"
          min-height="40vh"
        />
        <recipe-image-placeholder v-else style="height: 40vh"/>
      </v-layout>
    </v-flex>
    <v-container>
      <h1 class="display-1 font-weight-light primary--text mt-2">
        {{ recipe.heading }}
      </h1>
      <recipe-statistics :recipe="recipe" my-4 />
      <recipe-ingredients :sections="recipe.ingredientsSections" />
      <recipe-steps :steps="recipe.stepsSections" />
      <recipe-tags :tags="recipe.tags" />
    </v-container>
  </div>
</template>

<script>
import RecipeStatistics from "@/components/RecipeStatistics";
import RecipeIngredients from "@/components/RecipeIngredients";
import RecipeSteps from "@/components/RecipeSteps";
import RecipeTags from "@/components/RecipeTags";
import {
  IMAGE_SIZE_LARGE,
  IMAGE_SIZE_LAZY,
  recipeImageUrl
} from "@/utils/ImageUtils";
import ImageGallery from "@/components/ImageGallery";
import RecipeImagePlaceholder from "@/components/RecipeImagePlaceholder.vue";

export default {
  name: "RecipesDetailPage",
  components: {
    RecipeImagePlaceholder,
    ImageGallery,
    RecipeTags,
    RecipeSteps,
    RecipeIngredients,
    RecipeStatistics
  },
  toolbar: {
    title: "Recept",
    overContent: true,
    color: "rgba(255, 255, 255, 0.85)",
    back: true
  },
  computed: {
    imageLazy() {
      return recipeImageUrl(this.recipe, IMAGE_SIZE_LAZY);
    },
    image() {
      return recipeImageUrl(this.recipe, IMAGE_SIZE_LARGE);
    },
    recipe() {
      return this.$store.getters["recipeByUrl"](this.$route.params.url);
    }
  }
};
</script>
